export default [
  'guestInvited',
  'projectArchived',
  'projectCreatedFromDeal',
  'quotaLimitReached',
  'recordLinked',
  'recordUnlinked',
  'templateApplied',
  'timelineInteraction',
  'viewSwitched'
]
